import { useEffect, useState } from "react";
import Button from "../atoms/button";

/** group=null → criação; group preenchido → edição (nome/descrição/membros). */
const GroupModal = ({ open, group, staff, onClose, onSubmit }) => {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [memberIds, setMemberIds] = useState([]);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setName(group?.name || "");
        setDescription(group?.description || "");
        setMemberIds((group?.members || []).map((member) => member._id));
    }, [group, open]);

    if (!open) return null;

    const toggleMember = (id) => {
        setMemberIds((prev) => prev.includes(id) ? prev.filter((m) => m !== id) : [...prev, id]);
    };

    const handleSubmit = async () => {
        setSaving(true);
        await onSubmit({ name: name.trim(), description: description.trim(), members: memberIds }, group);
        setSaving(false);
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
            <div className="w-[520px] rounded-lg border border-[#d59106] bg-[#1c1917] p-6">
                <h3 className="mb-4 text-lg">{group ? "Editar grupo" : "Criar grupo"}</h3>
                <div className="mb-3 flex flex-col gap-1">
                    <label htmlFor="group-name">Nome</label>
                    <input id="group-name" type="text" value={name} onChange={(e) => setName(e.target.value)}
                        className="rounded px-2 py-1 text-black" />
                </div>
                <div className="mb-4 flex flex-col gap-1">
                    <label htmlFor="group-description">Descrição</label>
                    <input id="group-description" type="text" value={description} onChange={(e) => setDescription(e.target.value)}
                        className="rounded px-2 py-1 text-black" />
                </div>
                <p className="mb-2">Membros (somente staff)</p>
                <ul className="mb-4 max-h-48 overflow-y-auto">
                    {staff.map((member) => (
                        <li key={member._id}>
                            <label className="flex items-center gap-2 px-1 py-1">
                                <input
                                    type="checkbox"
                                    checked={memberIds.includes(member._id)}
                                    onChange={() => toggleMember(member._id)}
                                />
                                {member.name} — {member.email}
                            </label>
                        </li>
                    ))}
                </ul>
                <div className="flex justify-end gap-3">
                    <Button classes="bg-gray-600 hover:bg-gray-700" click={onClose}>Cancelar</Button>
                    <Button classes="bg-[#d59106] hover:bg-orange-500" click={handleSubmit} disabled={saving || !name.trim()}>
                        Salvar grupo
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default GroupModal;
